<template>
  <div>
    <iframe class="iframe" src="https://hnzhyl.net/#/login?card=51082419980127733X" width='100%' height='100%' frameborder="0"></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang='less'>
</style>